import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { editTemplateGroupName } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function updateTemplateGroupName({
  params,
  accountId,
}: TVariables): Promise<TResult> {
  const response = await fetch(editTemplateGroupName(accountId), {
    method: 'PUT',
    headers: {
      Authorization: getTokenWithType(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  params: {
    RootContainer: string;
    ExistingDirectoryName: string;
    NewlySuggestedDirectoryName: string;
  };
  accountId: number;
};

type TSnapshot = unknown;

function useEditTemplateGroupName(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async ({ params, accountId }: TVariables) => {
    const { RootContainer } = params;
    const renamedResult = await updateTemplateGroupName({
      params,
      accountId,
    });
    if (renamedResult.Data) {
      if (RootContainer === 'layouts') {
        queryClient.invalidateQueries(
          ['getExistingTemplates', true, accountId, 'layouts'],
          {
            refetchInactive: true,
          },
        );
      } else if (RootContainer === 'tables') {
        queryClient.invalidateQueries(
          ['getExistingTemplates', true, accountId, 'tables'],
          {
            refetchInactive: true,
          },
        );
      }
    } else if (renamedResult.Errors) throw renamedResult;
    return renamedResult;
  });
}

export { useEditTemplateGroupName };
